import React from "react";
import { PLUS_SVG } from "../../utils/svgs";
import { AppCard, AppCardContent } from "../Generic/AppCard";
import { AppIcon } from "../Generic/AppIcon";

interface Props {
  value: string;
  onClick: () => void;
  style?: React.CSSProperties;
}

const PlusCard = (props: Props) => {
  return (
    <AppCard className="PlusCardButton" onClick={props.onClick} style={props.style}>
      <AppCardContent>
        <div className="__wrapper">
          <span>{props.value}</span>
          <AppIcon icon={PLUS_SVG} stroke="green" />
        </div>
      </AppCardContent>
    </AppCard>
  );
};

export default React.memo(PlusCard);
